let mappings = {};
mappings.states = [
    {"value": 0, "text": "ORDERED"},
    {"value": 2, "text": "PULLED"},
    {"value": -2, "text": "CANT PULL"},
    {"value": 14, "text": "SHIPPED TO WAREHOUSE"},
      {"value": -14, "text": "CANT SHIPPED TO WAREHOUSE"},

     {"value": 15, "text": "PENDING"},

    //pickup truck 
    {"value": 3, "text": "PICKED"},
    {"value": -3, "text": "CANT PICK"},

    // pick up truck 
    {"value": 30, "text": "DROPPED"},
    {"value": -30, "text": "CANT BE DROPPED"},
//DROPPED 
    {"value": 9, "text": "RECEIVED FROM WAREHOUSE"},
    {"value": -9, "text": "CANT RECEIVED FROM WAREHOUSE"},

    {"value": 10, "text": "DISPATCHED FOR STORE"},
    {"value": -10, "text": "CANNOT BEDISPATCHED FOR STORE"},

    {"value": 11, "text": "PICKED FROM DROP LOCATION"},
    {"value": -11, "text": "CANT PICKED FROM DROP LOC"},

    {"value": 13, "text": "DROPPED AT STORE"},
    {"value": -13, "text": "CANT BE DROPPED AT STORE"},

    //people who receive items from pickup truck 
    {"value": 4, "text": "RECEIVED FROM DROP LOCATION"},
    {"value": -4, "text": "CANT RECEIVE"},

    //people who make it ready to ship 
    {"value": 5, "text": "READY TO SHIP"},
    {"value": -5, "text": "CANT READY TO SHIP"},

    //poeple who load it into delivery trucks 
    {"value": 6, "text": "LOADED FOR DELIVERY"},
    {"value": -6, "text": "CANT BE LOADED FOR DELIVERY"},

    //truck driver who confirms that item is in truck for delivery 
    {"value": 12, "text": "SHIPPED FOR DELIVERY"},
    {"value": -12, "text": "CANT BE SHIPPED FOR DELIVERY"},

    //truck driver who delivers the item 
    {"value": 31, "text": "PARTIAL"},
    
    {"value": -7, "text": "UNABLE TO DELIVER"},
    
    {"value": 32, "text": "CANCELLED"},
    {"value": -34, "text": "DAMAGED"},
    
    {"value": -33, "text": "RETURNED"},
    {"value": 33, "text": "RECEIVED TO RETURN MERCHANDISE"},

    {"value": 1, "text": "DELIVERED"},
  
    {"value": -8, "text": "NEEDS ATTENTION"},

    {"value": 100, "text": "RETURNED TO WAREHOUSE"},
    {"value": 101, "text": "RETURNED TO MECCA SHIPPING"},
 
    // {"value": 10, "text": "LOADED"},
    // {"value": -10, "text": "CANNOT BE LOADED"},
];

mappings.states_dict = Object.assign({}, ...mappings.states.map((x) => ({[parseInt(x.value)]: x.text})));
mappings.merchandise_statuses = [
    {value: 1, text: "IN STOCK"},
    {value: 2, text: "BACKORDER"},
    {value: 3, text: "SPECIAL"}
]
mappings.merchandise_statuses_dict = Object.assign({}, ...mappings.merchandise_statuses.map((x) => ({[parseInt(x.value)]: x.text})));


export default mappings;



// WEBPACK FOOTER //
// ./src/utilities/mappings.js